export default [

     {
          path: '/certificates',
          name: 'Certificates',
          component: () => import("@/views/Page/Certificates/Certificates.vue"),
           meta: {
               title: 'Certificates',
          },
     },
     {
          path: '/certificates/view/:id',
          name: 'CertificateView',
          component: () => import("@/views/Page/Certificates/CertificateView.vue"),
           meta: {
               title: 'View Certificate',
          },
     }
];